import React from 'react';
import { WebsiteDesignProps } from './types';
import { Feather, Scroll, PenTool } from 'lucide-react';
import { Button } from "@/components/ui/button";

const InkParchment: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Scribe's Guild";

    return (
        <div className="bg-[#f0e6d2] text-[#2c1810] min-h-screen font-serif flex flex-col items-center justify-center border-[20px] border-[#fdfbf7] shadow-[inset_0_0_100px_rgba(0,0,0,0.1)]">
            {/* Ink Splatter */}
            <div className="fixed top-10 right-10 w-64 h-64 bg-[#2c1810] rounded-full opacity-5 filter blur-3xl pointer-events-none"></div>
            <div className="fixed bottom-10 left-10 w-48 h-48 bg-[#2c1810] rounded-full opacity-5 filter blur-2xl pointer-events-none"></div>

            <nav className="w-full max-w-4xl p-8 flex justify-between items-center border-b border-[#2c1810]/20 relative z-10">
                <div className="text-3xl font-bold tracking-tighter italic">
                    {schoolName}
                </div>
                <div className="flex gap-6 italic text-lg">
                    <a href="#" className="hover:text-[#8b4513]">Works</a>
                    <a href="#" className="hover:text-[#8b4513]">Masters</a>
                    <a href="#" className="hover:text-[#8b4513]">Contact</a>
                </div>
            </nav>

            <main className="w-full max-w-4xl py-20 px-8 text-center relative z-10">
                 <div className="mb-12">
                     <Feather size={48} className="mx-auto mb-6 text-[#2c1810]" />
                     <h1 className="text-6xl md:text-8xl font-medium leading-none mb-8">
                         The Art of <br/> <span className="italic relative pr-4">Thought
                             <svg className="absolute w-full h-4 bottom-0 left-0 text-[#2c1810] opacity-20" viewBox="0 0 100 10" preserveAspectRatio="none">
                                 <path d="M0 5 Q 50 10 100 5 L 100 10 L 0 10 Z" fill="currentColor" />
                             </svg>
                         </span>
                     </h1>
                     <p className="text-xl md:text-2xl text-[#5d4037] max-w-2xl mx-auto leading-relaxed italic">
                         "To write is to carve one's soul into history."
                     </p>
                 </div>

                 <div className="flex justify-center gap-12 mt-16">
                     <div className="flex flex-col items-center">
                         <div className="w-px h-16 bg-[#2c1810] mb-4 opacity-30"></div>
                         <Scroll size={24} className="mb-2 opacity-60" />
                         <span className="text-sm uppercase tracking-widest opacity-60">Study</span>
                     </div>
                     <div className="flex flex-col items-center">
                         <div className="w-px h-16 bg-[#2c1810] mb-4 opacity-30"></div>
                         <PenTool size={24} className="mb-2 opacity-60" />
                         <span className="text-sm uppercase tracking-widest opacity-60">Practice</span>
                     </div>
                 </div>
                 
                 <div className="mt-16">
                     <Button variant="outline" className="border-[#2c1810] text-[#2c1810] hover:bg-[#2c1810] hover:text-[#f0e6d2] rounded-full px-12 py-6 text-lg tracking-widest uppercase transition-all">
                         Apply for Apprenticeship
                     </Button>
                 </div>
            </main>
        </div>
    );
};

export default InkParchment;
